import React from "react";

const TemplateInsights = ({
  color = "black",
  fill = "red",
  stroke = "yellow",
}) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9048 1.66797H6.09526C3.37304 1.66797 1.66669 3.59471 1.66669 6.32227V13.6803C1.66669 16.4079 3.3651 18.3346 6.09526 18.3346H13.9048C16.6349 18.3346 18.3334 16.4079 18.3334 13.6803V6.32227C18.3334 3.59471 16.6349 1.66797 13.9048 1.66797Z"
          stroke={color}
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill={fill}
        />
        <path
          d="M6.14252 8.50195V14.2186"
          stroke={stroke}
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M10.0317 5.76758V14.2201"
          stroke={stroke}
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M13.8575 11.5234V14.2193"
          stroke={stroke}
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        {/* <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9048 1.66797H6.09526C3.37304 1.66797 1.66669 3.59471 1.66669 6.32227V13.6803C1.66669 16.4079 3.3651 18.3346 6.09526 18.3346H13.9048C16.6349 18.3346 18.3334 16.4079 18.3334 13.6803V6.32227C18.3334 3.59471 16.6349 1.66797 13.9048 1.66797Z"
          stroke={color}
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill={fill}
        /> */}
      </svg>
    </div>
  );
};

export default TemplateInsights;
